import type { ModelsResolver } from "@/models/resolvers";
import { revisionDefaultFields } from "@/models/resolvers";
import { useLogger } from "@/composables/logger";
import { useCacheOperations } from "@/composables/cache";
import { omitUnknowns } from "@/utils/utils";
const { info: logInfo } = useLogger("SCENARIOS_CORRELATION_RESOLVER");

export default {
  optimistic: {
    insert_revisions_scenario_correlations_revisions(vars, cache, info) {
      logInfo("Optimistic", { vars, cache, info });
      const affectedRows = vars.objects.length;

      return {
        __typename:
          "revisions_scenario_correlations_revisions_mutation_response",
        affected_rows: affectedRows,
        returning: vars.objects.map(obj => ({
          id: obj.id,
          __typename: "revisions_scenario_correlations_revisions",
          scenario_correlations_view: {
            ...obj,
            ...revisionDefaultFields(obj),
            __typename: "scenario_correlations"
          }
        }))
      };
    }
  }
} as ModelsResolver;
